// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'or-delete';

export const Component = () => (
  <path d='M0 14.655V9.818h24.521v4.837H0Zm18.63-6.8V0h1.006v7.855H18.63Zm4.933 0V0h.958v7.855h-.958ZM18.63 24.52v-7.855h1.006v7.855H18.63Zm4.933 0v-7.855h.958v7.855h-.958Z' />
);

export const viewBox = '0 0 25 25';
